import { startValues, endValues } from "./DrawerAnimationContext";

export const navigatorDefaultProps = (props = {}) => ({
    screenOptions: {
        headerShown: false,
        drawerType: props.showDrawer ? "permanent" : "front",
        drawerStyle: {
            ...(props.isSmallScreen || !props.showDrawer ? {
                left: endValues.width * -1,
                width: endValues.width,
            } : {
                left: 0,
                width: startValues.width,
                transform: [{ translateX: 0 }],
            })
        },
    },
});